import * as service from './service';
import * as report from './dataReport';
import * as tips from './tips';
import $ from 'jquery';
import { nowCharIndex } from './base';
import { startLoadingComment } from './scroll';
import { checkReserveStatus } from './reserve';

const upLoadTimeKey = ['首页', '奖励里程', '修仙模拟器', '人物介绍', '商店图'];
const events = {
  navControl() {
    // const $links = $('.nav-item');
    // $links.removeClass('active');
    $('.j-nav-item').on('click', ({ target }) => {
      if (!target.dataset.index) {
        return;
      }
      const index = ~~target.dataset.index;
      $('.j-nav-item').removeClass('active').eq(index).addClass('active');
      fullpage.moveTo(index + 1);
      $('.j-mobile-menu').fadeOut(500);
    });
  },
  // 处理角色动画
  handleCharPage(state = false) {
    if (state) {
      $('.j-char-container .swiper-slide-active i').addClass('active');
      $(`.j-char-introduction .char-text:nth-child(${nowCharIndex})`)
        .show()
        .addClass('active');
      return;
    }
    $('.j-char-container .swiper-slide-active i').removeClass('active');
    $(`.j-char-introduction .char-text:nth-child(${nowCharIndex})`).removeClass(
      'activeFast active'
    );
  },
};
$(function () {
  window.fullpage = new fullpage('#fullPage', {
    licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
    normalScrollElements: '.j-popup,.life-popup,.j-screenshot-popup',
    scrollingSpeed: 1500,
    onLeave: function (origin, destination, direction) {
      let to = destination.index;
      let from = origin.index;
      $(`.section${from + 1}`).addClass('show_water mask');
      $(`.section${to + 1}`).addClass('lastPage');
      report.uploadTimeCounter(upLoadTimeKey[from]);
      $('.pc-nav-show .j-nav-item')
        .removeClass('active')
        .eq(to)
        .addClass('active');
      $('.mobile-nav-show .j-menu-item')
        .removeClass('active')
        .eq(to)
        .addClass('active');
      timer && clearTimeout(timer);
      let timer = setTimeout(() => {
        $(`.section${from + 1}`).removeClass('show_water mask nextPage');
        $(`.section${to + 1}`)
          .removeClass('lastPage')
          .addClass('nextPage');
      }, 1200);
      from === 0 && !service.state.menu && $('.j-nav-wrap').trigger('click');
      to === 1 && $('.section2 .j-reserve-btn').addClass('active');
      from === 1 && $('.section2 .j-reserve-btn').removeClass('active');
      to === 2 && startLoadingComment();
      to === 3 && events.handleCharPage(true);
      from === 3 && events.handleCharPage(false);
    },
  });
  $('.j-moreChance,.j-jumpToGame').on('click', ({target}) => {
    if (!target.dataset.skipcheck && !checkReserveStatus()) {
      tips.alert('reserveNeed');
      $('.j-reserve-popup').fadeIn(500);
      return;
    }
    $('.j-popup,.j-lottery-popup').fadeOut(500);
    fullpage.moveTo(3);
  });
  events.navControl();
});
